import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { useEffect } from "react";
import { AuthProvider, useAuth } from "./lib/auth";
import Header from "./components/Header";
import Home from "./pages/Home";
import { LoginPage, SignupPage } from "./pages/Auth";
import GoogleCallback from "./pages/GoogleCallback";
import Casual from "./pages/Casual";
import Battle from "./pages/Battle";
import Practice from "./pages/Practice";
import Multiplayer, { MultiplayerQuick, MultiplayerLobbyCreate, MultiplayerLobbyJoin, MultiplayerLobby, MultiplayerMatch } from "./pages/Multiplayer";
import Private from "./pages/Private";
import PrivateMatch from "./pages/PrivateMatch";
import Leaderboard from "./pages/Leaderboard";
import Profile from "./pages/Profile";
import Donations from "./pages/Donations";
import WelcomeModal from "./components/WelcomeModal";
import GlobalHoverEffects from "./components/GlobalHoverEffects";
import { loadTheme } from "./components/SettingsModal";

// Apply persisted theme as early as possible so the very first paint matches.
loadTheme();

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="App min-h-screen">
          {/* MagicBento hover effects on every button, app-wide */}
          <GlobalHoverEffects />
          <Header/>
          <Routes>
            <Route path="/" element={<Home/>}/>
            <Route path="/login" element={<LoginPage/>}/>
            <Route path="/signup" element={<SignupPage/>}/>
            <Route path="/auth/google/callback" element={<GoogleCallback/>}/>
            <Route path="/casual" element={<Casual/>}/>
            <Route path="/battle" element={<Battle/>}/>
            <Route path="/practice" element={<Practice/>}/>
            <Route path="/multiplayer" element={<Multiplayer/>}/>
            <Route path="/multiplayer/quick" element={<MultiplayerQuick/>}/>
            <Route path="/multiplayer/lobby/create" element={<MultiplayerLobbyCreate/>}/>
            <Route path="/multiplayer/lobby/join" element={<MultiplayerLobbyJoin/>}/>
            <Route path="/multiplayer/lobby/:code" element={<MultiplayerLobby/>}/>
            <Route path="/multiplayer/match/:matchId" element={<MultiplayerMatch/>}/>
            <Route path="/private" element={<Private/>}/>
            <Route path="/private/:code" element={<Private/>}/>
            <Route path="/private/match/:matchId" element={<PrivateMatch/>}/>
            <Route path="/leaderboard" element={<Leaderboard/>}/>
            <Route path="/profile/:username" element={<Profile/>}/>
            <Route path="/donate" element={<Donations/>}/>
            <Route path="/support" element={<Donations/>}/>
          </Routes>
          <Toaster theme="dark" position="top-right" toastOptions={{ style: { background: "#0B0C10", color: "#fff", border: "1px solid #1A1C23", borderRadius: "2px" } }}/>
          <GlobalWelcomeMount />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

// Renders the post-login welcome modal once we have a freshly authed user.
function GlobalWelcomeMount() {
  const { welcomeUser, setWelcomeUser } = useAuth();
  // Greeting label varies for new accounts vs returning players. We can't be
  // 100% certain here, so default to "WELCOME BACK".
  return (
    <WelcomeModal
      open={!!welcomeUser}
      user={welcomeUser}
      message="WELCOME BACK"
      onClose={() => setWelcomeUser(null)}
    />
  );
}

export default App;
